<template>
  <section>
    <form class="topup-form" @submit="submit">
      <div class="topup-form-frame">
        <h1 class="step-title" v-html="$t('component.stage2.title')"></h1>
        <section class="topup-amounts-container" v-for="(topup, topupIndex) in form.topup" :key="topupIndex">
          <h2 class="dark-title" v-if="!topup.isContact" v-html="$t('component.stage2.header', {phone: topup.phone})"></h2>
          <h2 class="dark-title" v-if="topup.isContact" v-html="$t('component.stage2.headerLogged', {contactName: topup.contact.description, phone: topup.msisdn})"></h2>
          <div class="topup-promo" v-if="topupIndex === 0">
            <div class="topup-promo-img">
              <span>
                <img src="../../../assets/images/promo.png" alt="" />
              </span>
            </div>
            <div>
              <h3>{{ $t('component.stage2.advTitle') }}</h3>
              <p>{{ $t('component.stage2.advText') }}</p>
              <p>
                <a id="link-promo" href="/files/plus/Regulamin_4_doladowania_i_gratis.pdf" target="_blank" rel="noreferrer" class="topup-text-link"
                   :title="$t('component.stage2.a11y.advLink')">{{ $t('component.stage2.advLink') }}</a>
              </p>
            </div>
          </div>
          <div>
            <ul class="topup-amounts">
              <li class="topup-amount" tabindex="0" as="button"
                  :class="['topup-' + amount, {active: isAmountSet(amount, topupIndex)}]"
                  v-for="(amount, amountIndex) in TOPUP_AMOUNTS"
                  :key="amountIndex"
                  ref="amount"
                  @click="setTopupAmount(amount, topupIndex)"
                  @keydown.enter="setTopupAmount(amount, topupIndex)"
                  @keydown.space.prevent="setTopupAmount(amount, topupIndex)">
                <span>
                  <span class="topup-amount-value">{{amount}}</span> zł
                </span>
                <span class="topup-amount-recommend" v-if="isAmountRecommended(amount)">{{ $t('component.stage2.recommend') }}</span>
              </li>
              <li class="topup-amount" tabindex="0" as="button"
                  ref="topupAmountOther"
                  :class="{active: topup.isAmountOtherSet}"
                  @click="enableOtherAmount(topupIndex)"
                  @keydown.enter="enableOtherAmount(topupIndex)"
                  @keydown.space.prevent="enableOtherAmount(topupIndex)">
                <span v-if="!isAmountOtherSet(topupIndex)">
                  <span class="topup-amount-value-other" v-html="$t('component.stage2.otherAmount')"></span>
                </span>
                <span class="topup-amount-value-field" v-if="isAmountOtherSet(topupIndex)">
                  <input id="topup-amount-other" type="text" v-model="topup.amountOther" @change="formatAmount(topupIndex)" aria-label="other amount">
                </span>
                <span v-if="isAmountOtherSet(topupIndex)" class="topup-amount-recommend">{{TOPUP_AMOUNT_MIN}}-{{TOPUP_AMOUNT_MAX}} zł</span>
              </li>
            </ul>
            <div class="topup-amount-message" v-if="isAmountMinMessage(topupIndex)" v-html="$t('component.stage2.messageAmountMin', {amount: TOPUP_AMOUNT_MIN})"></div>
            <div class="topup-amount-message" v-if="isAmountMaxMessage(topupIndex)" v-html="$t('component.stage2.messageAmountMin', {amount: TOPUP_AMOUNT_MAX})"></div>
          </div>
          <div class="topup-reminder" v-if="isReminderEnabled()">
            <div class="with-checkbox">
              <input type="checkbox"
                     :id="'reminder' + topupIndex" v-model="topup.setReminder"
                     @change="setReminderTime(topup)"
                     @keydown.enter.prevent />
              <label class="check-label" :for="'reminder' + topupIndex">
                <span class="check-label-box"></span>
                <span class="check-label-text" v-html="$t('component.stage2.setReminder')"></span>
              </label>
            </div>
            <div class="topup-reminder-select" v-if="topup.setReminder">
              {{ $t('component.stage2.setReminderIn') }}
              <select v-model="topup.reminderTime" :aria-label="$t('component.stage2.setReminderIn')" @keydown.enter.prevent>
                <option :value="value" v-for="value in TOPUP_REMINDER_TIME" :key="value" :aria-label="value">{{value}} {{ $t('component.stage2.setReminderDays') }}</option>
              </select>
            </div>
          </div>
          <div class="topup-contact-save" v-if="isUserLogged && !topup.isContact">
            <div class="with-checkbox">
              <input type="checkbox" :id="'saveContact' + topupIndex" v-model="topup.saveContact" @keydown.enter.prevent />
              <label class="check-label" :for="'saveContact' + topupIndex">
                <span class="check-label-box"></span>
                <span class="check-label-text" v-html="$t('component.stage2.saveContact')"></span>
              </label>
            </div>
            <div class="topup-contact-name" v-if="topup.saveContact">
              <label :aria-label="$t('component.stage2.placeholderContactName')">
                <input type="text"
                       maxlength="30"
                       v-model.trim="topup.contact.name"
                       :placeholder="$t('component.stage2.placeholderContactName')"
                       @keydown.enter.prevent>
              </label>
            </div>
          </div>
        </section>
      </div>
      <div class="topup-form-buttons">
        <button id="go-back-step-2" type="button" @click="goBack"
                :title="$t('component.autotopup.stage2.a11y.toPreviousStepButton')">‹ {{ $t('component.stage2.buttonBack') }}</button>
        <button id="submit-step-2" type="submit" :disabled="!isFormValid()"
                :title="$t('component.autotopup.stage2.a11y.toNextStepButton')">{{ $t('component.stage2.buttonNext') }} ›</button>
      </div>
    </form>
  </section>
</template>

<script>
import TopupStage2Mixin from '@/common/mixins/Topup/Stage2.mixin'

export default {
  name: 'TopupStage2',
  mixins: [TopupStage2Mixin],
  mounted () {
    let focusArea = this.$refs.amount
    if (focusArea) {
      focusArea[0].focus()
    }
  }
}
</script>

<style src="../../../assets/scss/topup-form.scss" lang="scss"></style>
